export default "assets/images/logo-dark-f9f5188c.png";